import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

/**
 *
 * @returns authenicated components
 */
const privateRoute = () => {
  const isAuthenticated = JSON.parse(window.sessionStorage.getItem('popIn'));
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default privateRoute;
